

import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, Row, Col, Alert } from "reactstrap";
import Switch from "react-switch";
import useToken from "../../../helpers/useToken"
import TMHLoader from "../../TMHLoader/TMHLoader"

export default function ApprovalRules({ notify, setTrigger, trigger }) {
    const { token } = useToken()
    const [isLoading, setIsLoading] = useState(false)

    const [approvalRules, setApprovalRules] = React.useState();

    useEffect(() => {
        const initData = () => {
            console.log('ApprovalTable: update data')
            setIsLoading(true)
            const myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };


            fetch(process.env.REACT_APP_BASE_URL + "approval_rule_config", requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        const json = result.json;
                        if (result.ok) {
                            setApprovalRules(json)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [token])

    const handleSubmit = () => {
        console.log('ApprovalTable: submit data')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(approvalRules)
        }


        fetch(process.env.REACT_APP_BASE_URL + "approval_rule_config", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    if (result.ok) {
                        notify('tl', 'Update approval rules success!', 'success')
                        setTrigger(!trigger)
                        setApprovalRules(json)
                        setIsLoading(false)
                    }
                    else {
                        notify('tl', 'Update approval rules failed!\n' + result.json.message, 'danger')
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            )
    }


    return (
        <TMHLoader active={isLoading}>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h2">
                                Approval Rules
                            </CardTitle>
                            {
                                approvalRules &&
                                <CardBody>
                                    <Row>
                                        <Col md="3" tag="h4">
                                            <Alert style={{ "padding": 6 }} color="default">
                                                Auto approve all code requests
                                            </Alert>
                                        </Col>
                                        <Col style={{ "paddingTop": 5 }}>
                                            <Switch onChange={() => {
                                                let i;
                                                const approvalRulesTemp = { ...approvalRules };
                                                approvalRulesTemp.auto_approval_all = !approvalRules.auto_approval_all
                                                if (!approvalRulesTemp.auto_approval_all) {
                                                    approvalRulesTemp.manual_approve_for_user.is_enable = false
                                                }
                                                for (i = 0; i < approvalRulesTemp.auto_approve_first.length; i++) {
                                                    approvalRulesTemp.auto_approve_first[i].is_enable = false
                                                }

                                                for (i = 0; i < approvalRulesTemp.auto_approve_all_up_to_round.length; i++) {
                                                    approvalRulesTemp.auto_approve_all_up_to_round[i].is_enable = false
                                                }
                                                setApprovalRules(approvalRulesTemp)

                                            }} checked={approvalRules.auto_approval_all} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="5" tag="h4">
                                            <Alert style={{ "padding": 6 }} color="default">
                                                Manual approve all requests for any user with
                                            </Alert>
                                        </Col>
                                        <Col md="0.5">
                                            <Alert style={{ "padding": 6 }} color="default">
                                                <select
                                                    value={approvalRules.manual_approve_for_user.number_codes}
                                                    onChange={(e) => {
                                                        var approvalRulesTemp = { ...approvalRules }
                                                        approvalRulesTemp.manual_approve_for_user.number_codes = parseInt(e.target.value)
                                                        setApprovalRules(approvalRulesTemp)
                                                    }}
                                                    style={{ "fontSize": "1.0624999875rem", "fontWeight": 400, "backgroundColor": "#54648b", "border": "none", "color": "#ffffff" }} type="select">
                                                    <option>10</option>
                                                    <option>15</option>
                                                    <option>20</option>
                                                    <option>25</option>
                                                    <option>30</option>
                                                    <option>35</option>
                                                    <option>40</option>
                                                </select>
                                            </Alert>

                                        </Col>
                                        <Col md="2" tag="h4">
                                            <Alert style={{ "padding": 6 }} color="default">
                                                code or more
                                            </Alert>

                                        </Col>
                                        <Col style={{ "paddingTop": 5 }}>
                                            <Switch onChange={() => {
                                                var approvalRulesTemp = { ...approvalRules }
                                                approvalRulesTemp.manual_approve_for_user.is_enable = !approvalRules.manual_approve_for_user.is_enable
                                                if (approvalRulesTemp.manual_approve_for_user.is_enable) {
                                                    let i;
                                                    approvalRulesTemp.auto_approval_all = true
                                                    for (i = 0; i < approvalRulesTemp.auto_approve_first.length; i++) {
                                                        approvalRulesTemp.auto_approve_first[i].is_enable = false
                                                    }

                                                    for (i = 0; i < approvalRulesTemp.auto_approve_all_up_to_round.length; i++) {
                                                        approvalRulesTemp.auto_approve_all_up_to_round[i].is_enable = false
                                                    }
                                                }


                                                setApprovalRules(approvalRulesTemp)

                                            }} checked={approvalRules.manual_approve_for_user.is_enable} />
                                        </Col>
                                    </Row>
                                    {
                                        approvalRules.auto_approve_first.map((approvalData, index) => {
                                            return (
                                                <Row key={index}>
                                                    <Col md="2" tag="h4">
                                                        <Alert style={{ "padding": 6 }} color="default">
                                                            Auto approve first
                                                        </Alert>
                                                    </Col>
                                                    <Col md="0.5">
                                                        <Alert style={{ "padding": 6 }} color="default">
                                                            <select
                                                                value={approvalRules.auto_approve_first[index].number_codes}
                                                                onChange={(e) => {
                                                                    var approvalRulesTemp = { ...approvalRules }
                                                                    approvalRulesTemp.auto_approve_first[index].number_codes = parseInt(e.target.value)
                                                                    setApprovalRules(approvalRulesTemp)
                                                                }}
                                                                style={{ "fontSize": "1.0624999875rem", "fontWeight": 400, "backgroundColor": "#54648b", "border": "none", "color": "#ffffff" }} type="select">
                                                                <option>1</option>
                                                                <option>2</option>
                                                                <option>3</option>
                                                                <option>4</option>
                                                                <option>5</option>
                                                                <option>6</option>
                                                                <option>7</option>
                                                                <option>8</option>
                                                                <option>9</option>
                                                                <option>10</option>
                                                                <option>11</option>
                                                                <option>12</option>
                                                                <option>13</option>
                                                                <option>14</option>
                                                                <option>15</option>
                                                            </select>
                                                        </Alert>
                                                    </Col>
                                                    <Col md="2" tag="h4">
                                                        <Alert style={{ "padding": 6 }} color="default">
                                                            codes when
                                                        </Alert>

                                                    </Col>
                                                    <Col md="2" tag="h4">
                                                        <Alert style={{ "padding": 6 }} color="default">
                                                            Sign up method is
                                                        </Alert>
                                                    </Col>
                                                    <Col md="3">
                                                        <Alert style={{ "padding": 6, textAlign: 'center' }} color="default">
                                                            <select
                                                                value={approvalRules.auto_approve_first[index].method}
                                                                onChange={(e) => {
                                                                    var approvalRulesTemp = { ...approvalRules }
                                                                    approvalRulesTemp.auto_approve_first[index].method = e.target.value
                                                                    setApprovalRules(approvalRulesTemp)
                                                                }}
                                                                style={{ "fontSize": "1.0624999875rem", "fontWeight": 400, "backgroundColor": "#54648b", "border": "none", "color": "#ffffff"}} type="select">
                                                                <option>FreeMovieHouse</option>
                                                                <option>FreeMovieQuiz</option>
                                                                <option>FreeMovieSpin</option>
                                                                <option>MobileApp</option>
                                                                <option>MobileApp/FreeMovieHouse</option>
                                                                <option>MobileApp/FreeMovieSpin</option>
                                                            </select>
                                                        </Alert> {" "}
                                                    </Col>
                                                    {
                                                        (index === approvalRules.auto_approve_first.length - 1) &&
                                                        <>
                                                            <Button
                                                                disabled={index === 5}
                                                                onClick={() => {
                                                                    var approvalRulesTemp = { ...approvalRules }
                                                                    approvalRulesTemp.auto_approve_first.push({ ...approvalRulesTemp.auto_approve_first[index] })
                                                                    setApprovalRules(approvalRulesTemp)

                                                                }}
                                                                className="btn-icon btn-simple" color="success" size="sm">
                                                                <i className="fa-solid fa-copy" />
                                                            </Button>
                                                            <Button
                                                                disabled={index === 0}
                                                                onClick={() => {
                                                                    var approvalRulesTemp = { ...approvalRules }
                                                                    approvalRulesTemp.auto_approve_first.pop()
                                                                    setApprovalRules(approvalRulesTemp)

                                                                }}
                                                                className="btn-icon btn-simple" color="danger" size="sm">
                                                                <i className="fa-solid fa-square-minus"></i>
                                                            </Button>
                                                        </>
                                                    }
                                                    <Col style={{ "paddingTop": 5 }}>
                                                        <Switch
                                                            onChange={() => {
                                                                var approvalRulesTemp = { ...approvalRules }
                                                                approvalRulesTemp.auto_approve_first[index].is_enable = !approvalRules.auto_approve_first[index].is_enable
                                                                approvalRulesTemp.auto_approval_all = false
                                                                approvalRulesTemp.manual_approve_for_user.is_enable = false
                                                                setApprovalRules(approvalRulesTemp)

                                                            }}
                                                            checked={approvalRules.auto_approve_first[index].is_enable}
                                                        />
                                                    </Col>
                                                </Row>)
                                        })
                                    }
                                    {
                                        approvalRules.auto_approve_all_up_to_round.map((data, index) => {
                                            return (
                                                <Row key={index}>
                                                    <Col md="4" tag="h4">
                                                        <Alert style={{ "padding": 6 }} color="default">
                                                            Auto approve  all codes up to round
                                                        </Alert>
                                                    </Col>
                                                    <Col md="0.5">
                                                        <Alert style={{ "padding": 6 }} color="default">
                                                            <select
                                                                value={approvalRules.auto_approve_all_up_to_round[index].number_rounds}
                                                                onChange={(e) => {
                                                                    var approvalRulesTemp = { ...approvalRules }
                                                                    approvalRulesTemp.auto_approve_all_up_to_round[index].number_rounds = parseInt(e.target.value)
                                                                    setApprovalRules(approvalRulesTemp)
                                                                }}
                                                                style={{ "fontSize": "1.0624999875rem", "fontWeight": 400, "backgroundColor": "#54648b", "border": "none", "color": "#ffffff" }} type="select">
                                                                <option>1</option>
                                                                <option>2</option>
                                                                <option>3</option>
                                                                <option>4</option>
                                                                <option>5</option>
                                                                <option>6</option>
                                                                <option>7</option>
                                                                <option>8</option>
                                                                <option>9</option>
                                                                <option>10</option>
                                                                <option>11</option>
                                                                <option>12</option>
                                                                <option>13</option>
                                                                <option>14</option>
                                                            </select>
                                                        </Alert>
                                                    </Col>
                                                    <Col md="2" tag="h4">
                                                        <Alert style={{ "padding": 6 }} color="default">
                                                            When sign up method is
                                                        </Alert>

                                                    </Col>
                                                    <Col md="3">
                                                        <Alert style={{ "padding": 6, textAlign: 'center' }} color="default">
                                                            <select
                                                                value={approvalRules.auto_approve_all_up_to_round[index].method}
                                                                onChange={(e) => {
                                                                    var approvalRulesTemp = { ...approvalRules }
                                                                    approvalRulesTemp.auto_approve_all_up_to_round[index].method = e.target.value
                                                                    setApprovalRules(approvalRulesTemp)
                                                                }}
                                                                style={{ "fontSize": "1.0624999875rem", "fontWeight": 400, "backgroundColor": "#54648b", "border": "none", "color": "#ffffff" }} type="select">
                                                                <option>FreeMovieHouse</option>
                                                                <option>FreeMovieQuiz</option>
                                                                <option>FreeMovieSpin</option>
                                                                <option>MobileApp</option>
                                                                <option>MobileApp/FreeMovieHouse</option>
                                                                <option>MobileApp/FreeMovieSpin</option>
                                                            </select>
                                                        </Alert>
                                                    </Col>
                                                    {
                                                        (index === approvalRules.auto_approve_all_up_to_round.length - 1) &&
                                                        <>

                                                            <Button
                                                                disabled={index === 5}
                                                                onClick={() => {
                                                                    var approvalRulesTemp = { ...approvalRules }
                                                                    approvalRulesTemp.auto_approve_all_up_to_round.push({ ...approvalRulesTemp.auto_approve_all_up_to_round[index] })
                                                                    setApprovalRules(approvalRulesTemp)

                                                                }}
                                                                className="btn-icon btn-simple" color="success" size="sm">
                                                                <i className="fa-solid fa-copy" />
                                                            </Button>
                                                            <Button
                                                                disabled={index === 0}
                                                                onClick={() => {
                                                                    var approvalRulesTemp = { ...approvalRules }
                                                                    approvalRulesTemp.auto_approve_all_up_to_round.pop()
                                                                    setApprovalRules(approvalRulesTemp)

                                                                }}
                                                                className="btn-icon btn-simple" color="danger" size="sm">
                                                                <i className="fa-solid fa-square-minus"></i>
                                                            </Button>
                                                        </>
                                                    }
                                                    <Col style={{ "paddingTop": 5 }}>
                                                        <Switch
                                                            onChange={() => {
                                                                var approvalRulesTemp = { ...approvalRules }
                                                                approvalRulesTemp.auto_approve_all_up_to_round[index].is_enable = !approvalRules.auto_approve_all_up_to_round[index].is_enable
                                                                approvalRulesTemp.auto_approval_all = false
                                                                approvalRulesTemp.manual_approve_for_user.is_enable = false
                                                                setApprovalRules(approvalRulesTemp)

                                                            }}
                                                            checked={approvalRules.auto_approve_all_up_to_round[index].is_enable}
                                                        />
                                                    </Col>
                                                </Row>)
                                        })
                                    }

                                    <div className="text-center"><Button onClick={() => handleSubmit()}>SAVE</Button></div>
                                </CardBody>
                            }
                        </CardHeader>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>
    )
}